import * as React from "react";
import {NavLink} from "react-bootstrap";

interface Props {
    linkName: React.ReactNode,
    linkTo: string,
    active: boolean,
}

export default class ItemLink extends React.Component<Props> {

    public render(): React.ReactNode {
        const {linkName, linkTo, active} = this.props;

        return (
            <NavLink href={linkTo}
                     className={`item ${active && 'selected'}`}
            >
                {linkName}
            </NavLink>
        )
    }
}